module.exports = __webpack_public_path__ + "static/media/suspension_yellow.8c779ac3.png";